import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AuthModal } from 'src/App/Dashboards/Market/Modals';
import { getTokenThunk } from 'src/store/Auth/actions';
import { useUserAffiliateInfo } from './hooks';
import MonthlyKpis from './MonthlyKpis';
import PartnerInformation from './PartnerInformation';
import ShareReferralLink from './ShareReferralLink';
import { useParams } from 'react-router-dom';
import { Alert, Box, Button, Grid, Skeleton, Typography } from '@mui/material';
import PartnerPasswordModal from './AffiliatePasswordModal';
import { User } from 'src/interfaces/iuser';
import CreateAffiliateLink from './CreateAffiliateLink';

const AffliateDashboard = ({}) => {
  const dispatch = useDispatch();
  const isLoggedIn = Boolean(dispatch(getTokenThunk()));
  const params: any = useParams();

  const user: User = useSelector((state: any) => state.dashboard.user);
  const { userAffiliateInfo, affiliateKey, error } = useUserAffiliateInfo(params?.partnerKey || '');
  const affiliateLink = `${window.location.protocol}//${window.location.host}/?affiliatedBy=${affiliateKey}`;
  const [openPartnerPasswordModal, setOpenPartnerPasswordModal] = useState<boolean>(false);

  return (
    <>
      {isLoggedIn && (
        <Grid container justifyContent="space-between" sx={{ mb: 2, p: 3, pb: 0 }}>
          <Grid item>
            <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
              Affiliate Dashboard
            </Typography>
          </Grid>
          <Grid item>
            {params.partnerKey && user.role === 'admin' && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => setOpenPartnerPasswordModal(true)}
              >
                Reset Password
              </Button>
            )}
          </Grid>
        </Grid>
      )}

      {!isLoggedIn && (
        <AuthModal
          authModalOpen={true}
          setAuthModalOpen={() => {}}
          getUserInfo={() => {}}
          getTokenThunk={() => {}}
          matches={() => {}}
          landing={() => {}}
        />
      )}

      {isLoggedIn && userAffiliateInfo && userAffiliateInfo === 'loading' && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            p: 3,
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <Skeleton variant="text" height={60} width={'100%'} />
          <Skeleton variant="rectangular" height={110} width={'100%'} />
          <Skeleton variant="rectangular" height={110} width={'100%'} />
        </Box>
      )}

      {isLoggedIn && !userAffiliateInfo && error && error !== 'no-affiliate' && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            p: 3,
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <Alert severity="error" sx={{ width: '100%' }}>
            {error}
          </Alert>
        </Box>
      )}

      {isLoggedIn && error && !user.affiliateKey && <CreateAffiliateLink />}

      {isLoggedIn && (
        <div>
          {userAffiliateInfo && userAffiliateInfo !== 'loading' && (
            <>
              <PartnerInformation
                email={userAffiliateInfo?.email}
                affiliateLink={affiliateLink}
                affiliateKey={affiliateKey}
                isAdminView={params?.partnerKey}
              />
              <MonthlyKpis data={userAffiliateInfo} />
              <ShareReferralLink referralLink={affiliateLink} />
            </>
          )}
        </div>
      )}

      <PartnerPasswordModal
        openPartnerPasswordModal={openPartnerPasswordModal}
        setOpenPartnerPasswordModal={setOpenPartnerPasswordModal}
      />
    </>
  );
};

export default AffliateDashboard;
